import React, { useEffect, useRef } from "react";
import "./LogoSlider.css";

const LogoSlider = () => {
  const logos = [
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-bold-news.png",
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-hotel-california.png",
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-bello.png",
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-celeste.png",
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-estato.png",
    "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/logo-hotel-berg.png",
  ];

  // Create multiple copies for seamless infinite loop
  const allLogos = [...logos, ...logos, ...logos, ...logos];
  const sliderRef = useRef(null);

  // Pause animation on hover
  const pauseAnimation = () => {
    if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = 'paused';
    }
  };

  // Resume animation
  const resumeAnimation = () => {
    if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = 'running';
    }
  };

  useEffect(() => {
    // Ensure animation runs smoothly
    if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = 'running';
    }
  }, []);

  return (
    <div className="blai-slider-container">
      <div className="blai-slider-section">
        <div className="blai-title-wrapper">
          <h2 className="blai-slider-title">
            Trusted by<span className="bst-title-secondary"> Leading Companies</span>
          </h2>
          <div className="blai-title-line"></div>
        </div>
        
        <div 
          className="blai-slider-wrapper"
          onMouseEnter={pauseAnimation}
          onMouseLeave={resumeAnimation}
        >
          <div 
            ref={sliderRef}
            className="blai-slide-track"
          >
            {allLogos.map((logo, i) => (
              <div key={i} className="blai-slide-item">
                <img 
                  src={logo} 
                  alt="brand logo" 
                />
              </div>
            ))}
          </div>
          
          {/* Gradient Overlays for smooth edges */}
          <div className="blai-slider-fade blai-fade-left"></div>
          <div className="blai-slider-fade blai-fade-right"></div>
        </div>
      </div>
    </div>
  );
};

export default LogoSlider;